import React from 'react';
import { useT } from '@/i18n/labels';

interface LoadingSpinnerProps {
  /** Text to display below the spinner. */
  message?: string;
}

const spinnerStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2rem',
  gap: '0.75rem',
};

const circleStyle: React.CSSProperties = {
  width: 40,
  height: 40,
  border: '4px solid #e5e7eb',
  borderTopColor: '#3b82f6',
  borderRadius: '50%',
  animation: 'spin 0.8s linear infinite',
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message }) => {
  const { t } = useT();
  const text = message ?? t('loadingSpinnerDefault');
  return (
    <div style={spinnerStyle} role="status" aria-label={text}>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <div style={circleStyle} />
      <span style={{ color: '#6b7280', fontSize: '0.875rem' }}>{text}</span>
    </div>
  );
};
